"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAnswers = exports.getQuestions = exports.getQuizResult = exports.updateAnswer = exports.getQuestion = void 0;
const base_1 = require("./base");
const const_1 = require("./const");
const getQuestion = (passageId, questionId) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.get)(const_1.BASE_PATH + "/quiz/question", true, {
        passageId,
        questionId,
    });
});
exports.getQuestion = getQuestion;
const updateAnswer = (passageId, questionId, answer) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/quiz/answer", {
        passageId,
        questionId,
        answer,
    }, true);
});
exports.updateAnswer = updateAnswer;
const getQuizResult = (passageId) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.get)(const_1.BASE_PATH + "/quiz/result", true, {
        passageId,
    });
});
exports.getQuizResult = getQuizResult;
const getQuestions = (passageId) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.get)(const_1.BASE_PATH + "/quiz/questions", true, {
        passageId,
    });
});
exports.getQuestions = getQuestions;
const updateAnswers = (passageId, answers) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, base_1.post)(const_1.BASE_PATH + "/quiz/answers", {
        passageId,
        answers,
    }, true);
});
exports.updateAnswers = updateAnswers;
